module.exports = __webpack_public_path__ + "img/envato.d574fcc2.png";